import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardGuard } from './dashboard.guard';
import { CanDeactivateGuard } from './guards/can-deactivate-guard';


import { DashboardRoutingModule } from './dashboard-routing.module';
import { routingComponents } from './dashboard-routing.module';

import { DashboardComponent } from './dashboard.component';

import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { DataTableModule ,SharedModule } from 'primeng/primeng';
import { ToolbarModule } from 'primeng/primeng';
import { PanelModule } from 'primeng/primeng';
import { ButtonModule } from 'primeng/primeng';
import { InputTextModule } from 'primeng/primeng';
import { PasswordModule } from 'primeng/primeng';
import { DropdownModule } from 'primeng/primeng';
import { MultiSelectModule } from 'primeng/primeng';
import { CheckboxModule } from 'primeng/primeng';
import { InputSwitchModule } from 'primeng/primeng';
import { FileUploadModule } from 'primeng/primeng';
import { CalendarModule } from 'primeng/primeng';
import { GrowlModule } from 'primeng/primeng';
import { DialogModule } from 'primeng/primeng';
import { AutoCompleteModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { InputTextareaModule } from 'primeng/primeng';
import { RadioButtonModule } from 'primeng/primeng';
import { ProgressSpinnerModule } from 'primeng/primeng';
import { ProgressBarModule } from 'primeng/primeng';
import { BlockUIModule } from 'primeng/primeng';
import { PaginatorModule } from 'primeng/primeng';
import { ConfirmDialogModule } from 'primeng/primeng';
import { OverlayPanelModule } from 'primeng/primeng';
import { EditorModule } from 'primeng/primeng';
import { OperationListItemComponent } from './pages/operations/operation-list-item/operation-list-item.component';
import { SaleListItemsComponent } from './pages/sales/sale-list-items/sale-list-items.component';
import { TransactionPurposeTypeComponent } from './pages/transaction_purpose_types/transaction-purpose-type/transaction-purpose-type.component';
import { TransactionPurposeTypeCrudComponent } from './pages/transaction_purpose_types/transaction-purpose-type-crud/transaction-purpose-type-crud.component';
import { ReceiptListItemsComponent } from './pages/reseipts/receipt-list-items/receipt-list-items.component';
import { ReceiptUpdateComponent } from './pages/reseipts/receipt-update/receipt-update.component';




@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DataTableModule,
    SharedModule,
    ToolbarModule,
    PanelModule,
    ButtonModule,
    InputTextModule,
    PasswordModule,
    DropdownModule,
    MultiSelectModule,
    CheckboxModule,
    InputSwitchModule,
    FileUploadModule,
    CalendarModule,
    GrowlModule,
    DialogModule,
    AutoCompleteModule,
    FieldsetModule,
    InputTextareaModule,
    RadioButtonModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    BlockUIModule,
    PaginatorModule,
    ConfirmDialogModule,
    OverlayPanelModule,
    EditorModule,
    DashboardRoutingModule
  ],
  declarations: [
  	DashboardComponent,
  	routingComponents,
  	OperationListItemComponent,
  	SaleListItemsComponent,
  	TransactionPurposeTypeComponent,
  	TransactionPurposeTypeCrudComponent,
  	ReceiptListItemsComponent,
  	ReceiptUpdateComponent,
  	],
  providers: [DashboardGuard,CanDeactivateGuard]
})
export class DashboardModule { }
  


// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/dashboard.module.ts